class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.announcementBar = document.querySelector(".js-announcement-bar");
    this.awaitDY();
    this.lastScrollTop = 0;
  }

  awaitDY(){
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if(mutation.attributeName == "class" && mutation.target.classList.contains('dy_unit')){
          this.initDY(window.Marlow?.nano_bar?.enable_slider);
          observer.disconnect();
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(document.querySelector("#shopify-block-announcement-bar"), config);
  }

  initDY(slider){
    if (slider == "true") {
      this.initNanoSlider();
    } else {
      this.announcementBar.querySelector(".dy_countdown_banner_slide_2")?.remove();
      this.announcementBar.querySelector(".dy_countdown_banner_slide_3")?.remove();
      this.announcementBar.querySelector(".splide__arrows")?.remove();
    }
    this.initNanoLinks();
  }

  checkCookie = (cname) => {
    return Cookies.get("announcementBar") === "closed";
  };

  connectedCallback() {
    this.header = document.getElementById("shopify-section-header");
    this.closeAnnouncementButton = document.querySelector(".js-close-announcement");
    this.stickyHeaderWrapper = document.querySelector(".js-sticky-header-container");

    this.closeAnnouncementButton?.addEventListener("click", this.closeAnnouncementBar);

    const announcementCookieSet = this.checkCookie("announcementBar");
    if (announcementCookieSet) {
      this.closeAnnouncementBar();
    } else {
      this.showAnnouncementBar();
    }

    this.headerBounds = {};
    this.currentScrollTop = 0;

    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener("scroll", this.onScrollHandler, false);
    this.createObserver();

    if (window.scrollY > 0) {
      this.stickyHeaderWrapper.classList.add("shopify-section-header-sticky", "animate");
    }

    this.header.addEventListener("mouseenter", () => {
      this.stickyHeaderWrapper.classList.add("shopify-section-header-sticky", "animate");
    });

    this.header.addEventListener("mouseleave", () => {
      const menuDrawer = document.querySelector(".menu-drawer-container");
      if (window.scrollY == 0 && !menuDrawer.classList.contains("menu-opening")) {
        this.stickyHeaderWrapper.classList.remove("shopify-section-header-sticky", "animate");
        this.closeMenuDisclosure();
      }
    });
  }

  disconnectedCallback() {
    window.removeEventListener("wheel", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll(e) {
    /* scroll behavior: 
    - announcement bar is not sticky
    - header nav bar is sticky
    - if user scrolls down anywhere past 100px from the top of the page, hide the header nav bar
    - is user scrolls up anywhere on the page, show the header nav bar
    */

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop < this.lastScrollTop || scrollTop < 100) {
      //scroll up
      if (!this.stickyHeaderWrapper.classList.contains("header-scroll-up")) {
        this.stickyHeaderWrapper.classList.remove("header-scroll-down");
        this.stickyHeaderWrapper.classList.add("header-scroll-up");
      }
    } else {
      //scroll down
      if (this.stickyHeaderWrapper.classList.contains("header-scroll-up")) {
        this.stickyHeaderWrapper.classList.add("header-scroll-down");
        this.stickyHeaderWrapper.classList.remove("header-scroll-up");
      }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  hide() {
    this.stickyHeaderWrapper.classList.add("shopify-section-header-sticky");
    this.closeMenuDisclosure();
  }

  initNanoLinks() {
      [].forEach.call(document.querySelectorAll(".announcement-bar li[data-href]"), (el, i) => {
        if(el.getAttribute('data-href')){
          el.addEventListener('click', () => {
            window.open(el.getAttribute('data-href'), '_blank');
          })
        }
      });
  }
  initNanoSlider(){
      document.querySelector(".js-announcement-bar").querySelector(".count-down").style.display = "none";
      this.announcementBarSliderOptions = {
        type: "loop",
        pagination: false,
        drag: false,
        dots: false,
        autoplay: true,
        perPage: 1,
        arrowPath: "M3.23389 1L8.76586 7L3.23389 13",
      };
      if(!this.announcementBarSlider){
        this.announcementBarSlider = new Splide("#shopify-section-announcement-bar .splide", this.announcementBarSliderOptions);
        setTimeout(() => {
          this.announcementBar.querySelector(".count-down").style.display = "initial";
          this.announcementBarSlider.mount();
        }, 250);
        this.initNanoSliderEvents();
      }
  }
  initNanoSliderEvents() {
    window.addEventListener('click', (e) => {
      const autoplaySlider = this.announcementBarSlider.Components.Autoplay;
      this.announcementBar.contains(e.target) ? autoplaySlider.pause() : autoplaySlider.play();
    });
  }
  reveal() {
    this.stickyHeaderWrapper.classList.add("shopify-section-header-sticky", "animate");
  }

  reset() {
    this.stickyHeaderWrapper.classList.remove("shopify-section-header-sticky", "animate");
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll("details-disclosure");
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  setCookie = () => {
    Cookies.set("announcementBar", "closed");
  };

  closeAnnouncementBar = () => {
    this.announcementBar.classList.add("hidden");
    this.stickyHeaderWrapper.classList.remove("has-announcement");

    const announcementCookieSet = this.checkCookie("announcementBar");
    if (!announcementCookieSet) {
      this.setCookie();
    }
  };

  showAnnouncementBar = () => {
    this.stickyHeaderWrapper.classList.add("has-announcement");
    this.announcementBar.classList.add("loaded");
  };
}

customElements.define("sticky-header", StickyHeader);
